import { GetString } from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../Grid';

const circleDiameter = 28; // in px
const arrowSize = 30; // in px
const Root = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  grid-row-gap: 10px;
  color: #333;
  margin-bottom: 2rem;
  grid-template-columns:
    max-content
    ${arrowSize}px
    ${circleDiameter}px
    ${arrowSize}px
    1fr;

  @media ${smallMediaQuery} {
    margin-bottom: 1rem;
  }
`;

const Title = styled.div`
  grid-row: 1 / 3;
  grid-column: 1 / 2;
  display: flex;
  align-items: center;
  font-size: 1.1rem;

  @media ${smallMediaQuery} {
    font-size: 0.9rem;
  }
`;
const CircleBase = styled.div`
  grid-column: 3 / 4;
  border-radius: 50%;
  width: ${circleDiameter}px;
  height: ${circleDiameter}px;
  border-width: 2px;
  border-style: solid;
  transform: translateY(40%);
`;
const DoesExportCircle = styled(CircleBase)`
  grid-row: 1 / 2;
  background-image:
    linear-gradient(
      136deg,
      #8b8b9c 16.67%,
      #ebebeb 16.67%,
      #ebebeb 50%,
      #8b8b9c 50%,
      #8b8b9c 66.67%,
      #ebebeb 66.67%,
      #ebebeb 100%
    );
  background-size: 4.32px 4.17px;
  border-color: #8b8b9c;

  @media ${smallMediaQuery} {
    transform: translateY(20%);
  }
`;
const DoesNotExportCircle = styled(CircleBase)`
  grid-row: 2 / 3;
  background-color: #ebebeb;
  border-color: #8b8b9c;
`;
const Text = styled.div`
  grid-column: 5 / 6;
  font-size: 0.8rem;

  @media ${smallMediaQuery} {
    font-size: 0.7rem;
  }
`;

const NodeTitle = styled.div`
  font-size: 1rem;

  @media ${smallMediaQuery} {
    font-size: 0.8rem;
  }
`;

const DoesExportText = styled(Text)`
  grid-row: 1 / 2;
`;
const DoesNotExportText = styled(Text)`
  grid-row: 2 / 3;
`;
const ArrowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  position: relative;
  top: 2px;

  @media ${smallMediaQuery} {
    top: 0;
  }
`;

const arrowHTMLEntityCode = '&#x2192;';

interface Props {
  getFluentString: GetString;
}
export default ({getFluentString}: Props) => {
  return (
    <Root>
      <Title>{getFluentString('country-product-space-how-to-read-title')}</Title>
      <ArrowContainer
        dangerouslySetInnerHTML={{__html: arrowHTMLEntityCode}}
        style={{gridRow: '1 / 3', gridColumn: 2}}
      />
      <DoesExportCircle/>
      <DoesNotExportCircle/>
      <ArrowContainer
        dangerouslySetInnerHTML={{__html: arrowHTMLEntityCode}}
        style={{gridRow: 1, gridColumn: 4}}
      />
      <ArrowContainer
        dangerouslySetInnerHTML={{__html: arrowHTMLEntityCode}}
        style={{gridRow: 2, gridColumn: 4}}
      />
      <DoesExportText>
        <NodeTitle>Colored Node:</NodeTitle>
        {getFluentString('country-product-space-how-to-read-exported-product-text')}
      </DoesExportText>
      <DoesNotExportText>
        <NodeTitle>Gray Node:</NodeTitle>
        {getFluentString('country-product-space-how-to-read-not-exported-product-text')}
      </DoesNotExportText>
    </Root>
  );
};
